import { render, staticRenderFns } from "./DollarInput.vue?vue&type=template&id=177d95b6&scoped=true&"
import script from "./DollarInput.vue?vue&type=script&lang=js&"
export * from "./DollarInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d95b6",
  null
  
)

export default component.exports